import i18n from "../../../i18n";

export const contractsFields = [
    {
        key: "name",
        label: i18n.t("contracts.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "number",
        label: i18n.t("contracts.number"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "licences",
        label: i18n.t("contracts.licences"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "instanceName",
        label: i18n.t("contracts.instanceName"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "synchronized",
        label: i18n.t("contracts.Synchronized"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "actions",
        label: ""
    }
];
